import React from "react"; // Add this import
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Header from "./Component/Header";
import HeroSection from "./Component/ HeroSection";
import NotificationSlider from "./Component/NotificationSlider";
import GaonSection from "./Component/GaonSection";
import LeadersSection from "./Component/LeadersSection";
import VillageDevelopmentSection from "./Component/VillageDevelopmentSection";
import AwardsSection from "./Component/AwardsSection";
import Schemes from "./Component/Schemes";
import VillageForm from "./Component/VillageForm";
import GramFooter from "./Component/GramFooter";
import NagathaneHero from "./NagthaneComponent/NagathaneHero";
import MissionSection from "./NagthaneComponent/MissionSection";
import GoalsSection from "./NagthaneComponent/GoalsSection";
import LocationInfo from "./NagthaneComponent/LocationInfo";
import WayToReach from "./NagthaneComponent/ WayToReach";
import AdministrationSection from "./NagthaneComponent/ AdministrationSection";
import MembersSection from "./NagthaneComponent/MembersSection";
import SchoolsSection from "./NagthaneComponent/SchoolsSection";
import SuccessStorySection from "./AchievementsComponent/SuccessStorySection";
import GavVikasSection from "./AchievementsComponent/GavVikasSection";
import GalleryHero from "./GalleryComponent/ GalleryHero";
import HeadingSection from "./GalleryComponent/ HeadingSection";
import SchoolSocialSection from "./GalleryComponent/SchoolSocialSection";
import NaturalViewSection from "./GalleryComponent/NaturalViewSection";
import SwachhtaSection from "./GalleryComponent/SwachhtaSection";
import GramSabhaSection from "./GalleryComponent/GramSabhaSection";
import PayasbhutSection from "./GalleryComponent/PayasbhutSection";
import CMOHero from "./CampaignComponent/CMOHero";
import PanchayatSection from "./CampaignComponent/PanchayatSection";
import PanchayatMissionSection from "./CampaignComponent/PanchayatMissionSection";
import AabhiyanSevenPoints from "./CampaignComponent/AabhiyanSevenPoints";
import PreAbhiyanSection from "./CampaignComponent/ PreAbhiyanSection";
import DownloadCard from "./CampaignComponent/DownloadCard";
import ContactHeroSection from "./ContactComponent/ContactHeroSection";
import VillageFormMap from "./ContactComponent/VillageFormMap";
import NariShaktiSection from "./GalleryComponent/NariShaktiSection";
import SamajikSection from "./GalleryComponent/SamajikSection";
import ReligiousEventGallery from "./GalleryComponent/ ReligiousEventShowcase";
import EventGallery from "./GalleryComponent/ ReligiousEventShowcase";
import SarpanchDataGrid from "./NagthaneComponent/SarpanchDataGrid";

function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    // Now this will work
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      {/* ScrollToTop works for all route changes */}
      <ScrollToTop />

      <Header />

      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <NotificationSlider />
              <GaonSection />
              <LeadersSection />
              <VillageDevelopmentSection />
              <AwardsSection />
              <Schemes />
              <VillageForm />
              <GramFooter />
            </>
          }
        />

        <Route
          path="/about"
          element={
            <>
              <NagathaneHero />
              <NotificationSlider />
              <MissionSection />
              <GoalsSection />
              <LocationInfo />
              <WayToReach />
              <AdministrationSection />
              <MembersSection />
              <SarpanchDataGrid />
              <SchoolsSection />
              <VillageForm />
              <GramFooter />
            </>
          }
        />

        <Route
          path="/achievements"
          element={
            <>
              <SuccessStorySection />
              <GavVikasSection />
              <AwardsSection />
              <GramFooter />
            </>
          }
        />

        <Route
          path="/gallery"
          element={
            <>
              <GalleryHero />
              <HeadingSection />
              <SchoolSocialSection />
              <NaturalViewSection />
              <SwachhtaSection />
              <GramSabhaSection />
              <PayasbhutSection />
              <NariShaktiSection />
              <SamajikSection />
              <EventGallery />
              <GramFooter />
            </>
          }
        />

        <Route
          path="/campaign"
          element={
            <>
              <CMOHero />
              <PanchayatSection />
              <PanchayatMissionSection />
              <AabhiyanSevenPoints />
              <PreAbhiyanSection />
              <DownloadCard />
              <GramFooter />
            </>
          }
        />

        <Route
          path="/contact"
          element={
            <>
              <ContactHeroSection />
              <VillageFormMap />
              {/* <VillageForm/> */}
              <GramFooter />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
